import { differenceInDays, format, parse } from 'date-fns';
import { useEffect, useState } from 'react';
import { useLocalStorage } from '../../common/hooks/useLocalStorage';
import {
  CrossIcon,
  CrossWrapper,
  IconWrapper,
  InfoIcon,
  InfoWrapper,
  PHILink,
  Slide,
} from './PhiSlide.styles';

const PHI_SLIDE_KEY = 'PHI_SLIDE_KEY';

const DATE_FORMAT = 'yyyy-MM-dd';

export const PHISlide = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const [lastSeen, setLastSeen] = useLocalStorage<string | null>(PHI_SLIDE_KEY, null);

  useEffect(() => {
    const now = format(new Date(), DATE_FORMAT);

    if (lastSeen === null) {
      setIsVisible(true);
      setLastSeen(now);
    } else {
      const hasSeenInTheLastMonth =
        differenceInDays(new Date(), parse(lastSeen, DATE_FORMAT, new Date())) < 28;

      if (!hasSeenInTheLastMonth) {
        setIsVisible(true);
        setLastSeen(now);
      }
    }
  }, [lastSeen, setLastSeen]);

  const dismissSlide = () => {
    setIsVisible(false);
  };

  return (
    <Slide isVisible={isVisible}>
      <InfoWrapper>
        <InfoIcon />
      </InfoWrapper>
      <PHILink
        target="_blank"
        rel="noreferrer"
        href="https://healthengine.com.au/opi/3eDPCF9wzXVYH7MwHXj34q?icid=meo:serp:::med:phi:::tsu:nov21"
      >
        Do you need to review your health insurance to potentially save money? Click here.
      </PHILink>
      <IconWrapper onClick={dismissSlide}>
        <CrossWrapper>
          <CrossIcon isVisible={isVisible} />
        </CrossWrapper>
      </IconWrapper>
    </Slide>
  );
};
